import React, {
  memo,
  useCallback, useContext, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@mui/material';
import { Alert } from '@mui/lab';
import api from '../../../api/req';
import { AppContext } from '../../../providers/authProvider';

function ActivateUserButton({
  userid,
  disabled,
  active,
  onSuccess,
}) {
  const [isActive, setIsActive] = useState(false);
  useEffect(
    () => setIsActive(active),
    [active],
  );
  const [err, setErr] = useState(null);
  const { auth } = useContext(AppContext);
  const setActive = useCallback(
    async (value) => {
      const method = value ? api.put : api.delete;
      const data = { is_active: value };
      const r = await method(`/api/core/user/${userid}/set_active/`, auth, data);
      if (!r.ok) throw new Error(`Виникла помилка! Перевірте правильність заповнення. (${r.status} ${r.statusText})`);
      return true;
    },
    [auth, userid],
  );

  const onSetIsActive = useCallback(
    () => {
      const value = !isActive;
      setErr(null);
      setActive(value)
        .then(() => {
          setActive(value);
          if (onSuccess) onSuccess();
        })
        .catch((e) => setErr(e.message));
    },
    [isActive, onSuccess, setActive],
  );
  return (
    <div>
      <Button
        onClick={onSetIsActive}
        disabled={disabled}
        startIcon={<FontAwesomeIcon icon={isActive ? faUserSlash : faUserTag} />}
        variant="contained"
        color={isActive ? 'warning' : 'success'}
      >
        {isActive ? 'Деактивувати' : 'Активувати'}
      </Button>
      {err && (
        <Alert severity="error">{err}</Alert>
      )}
    </div>
  );
}
ActivateUserButton.propTypes = {
  userid: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  active: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func,
};

ActivateUserButton.defaultProps = {
  disabled: false,
  onSuccess: null,
};

export default memo(ActivateUserButton);
